import React, { useContext, useEffect } from "react";
import Accordion from "../../components/common/accordian";
import SimpleBackdrop from "../../components/loader/backdrop";
import CallToAction from "./partials/cta";
import CustomerDetailsForm from "./partials/customer";
import AssetDetailsForm from "./partials/asset";
import ErrorMessage from "./partials/error";
import ApplicationContext from "../../context/index";
import EstimationDetailsForm from "./partials/estimation";
import withStyles from "@material-ui/core/styles/withStyles";
import { Box } from "@material-ui/core";
import { BUTTON_SUBMIT_CLAIM } from "../../constants/index";
import { syncProposalDetails } from "../../helpers/proposal";
import { useStyles } from "./indexFormStyles";

function ProposalForm(props) {
  const {
    state: { orderDetails = null },
  } = useContext(ApplicationContext);
  const {
    classes: { container, main },
    disabledAccordion,
    errorMessage,
    errors,
    form,
    handleChange,
    isFormSubmitted,
    isSearchCompleted = true,
    onSubmit,
    setForm,
    photo,
    photoChangeHandler,
    refId = null,
    claimId = null,
    downloadFile,
  } = props;

  useEffect(() => {
    setForm({
      ...form,
      ...syncProposalDetails(orderDetails ? orderDetails : {}),
    });
  }, [orderDetails]);

  return (
    <Box className={main}>
      <Box container={"true"} justifyContent="center" className={container}>
        <form noValidate autoComplete="off" onSubmit={onSubmit}>
          <Accordion title={"Customer Details"} disabled={disabledAccordion}>
            <CustomerDetailsForm
              errorMessage={errorMessage}
              form={form}
              handleChange={handleChange}
              isFormSubmitted={isFormSubmitted}
            />
          </Accordion>

          <Accordion
            title={"Device & Coverage Details"}
            disabled={disabledAccordion}
          >
            <AssetDetailsForm
              errorMessage={errorMessage}
              form={form}
              handleChange={handleChange}
              isFormSubmitted={isFormSubmitted}
              downloadFile={downloadFile}
            />
          </Accordion>

          <Accordion
            title={"Repair Estimate"}
            defaultExpanded={true}
            disabled={false}
          >
            <EstimationDetailsForm
              errorMessage={errorMessage}
              form={form}
              handleChange={handleChange}
              photoChangeHandler={photoChangeHandler}
              isSearchCompleted={isSearchCompleted}
              refId={refId}
              claimId={claimId}
            />
          </Accordion>

          <ErrorMessage errors={errors} />

          {refId && claimId ? (
            <CallToAction
              buttonType={"submit"}
              errorMessage={errorMessage}
              form={form}
              isDisabled={
                isFormSubmitted ||
                !orderDetails ||
                !form?.estimate_amount ||
                errorMessage?.estimate_amount ||
                !photo?.estimate ||
                !form?.estimate_details ||
                !photo?.phone ||
                !form?.job_sheet_number ||
                errorMessage?.job_sheet_number
              }
              isFormSubmitted={isFormSubmitted}
              text={BUTTON_SUBMIT_CLAIM}
            />
          ) : (
            <CallToAction
              buttonType={"submit"}
              errorMessage={errorMessage}
              form={form}
              isDisabled={
                isFormSubmitted ||
                !orderDetails ||
                !form?.estimate_amount ||
                errorMessage?.estimate_amount ||
                !photo?.estimate ||
                !form?.damage_details ||
                errorMessage?.damage_details ||
                !photo?.aadhaar ||
                !photo?.phone
              }
              isFormSubmitted={isFormSubmitted}
              text={BUTTON_SUBMIT_CLAIM}
            />
          )}
        </form>

        {(!isSearchCompleted || isFormSubmitted) && <SimpleBackdrop />}
      </Box>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(ProposalForm);
